import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, EventType, Router } from '@angular/router';
import { AuthStore } from '@app/stores/auth.store';
import { filter } from 'rxjs';

@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  protected readonly authStore = inject(AuthStore);
  private readonly destroyRef = inject(DestroyRef);

  protected breadcrumbs: Array<{
    text: string;
    ref: string;
    isActive: boolean;
  }> = [];
  showSidebar = true;

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event.type == EventType.NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        let route = this.activatedRoute;
        while (route.firstChild) route = route.firstChild;
        const data = route.snapshot.data || {};
        this.breadcrumbs = data['breadcrumb'] ?? [];
        this.showSidebar = !data['hideSidebar'];
      });
  }

  ngOnInit(): void {
    if (!this.authStore.isAdmin()) {
      this.router.navigate(['/projects']);
    }
  }
}
